var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-md-center"},[_c('h1',[_vm._v("404")]),_c('h2',{staticClass:"my-3 headline"},[_vm._v("Sorry, page not found")]),_c('div',[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":_vm.goHome}},[_vm._v("Go Home")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }